module.exports = __webpack_public_path__ + "static/img/our-services_1.8a9d538.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/consulting/our-services_1.svg
// module id = zwHD
// module chunks = 0